import { __awaiter } from "tslib";
import { getCivicScore, getIdentityStore, searchIdentityStore, } from "./identity-store-api";
export class Store {
    constructor(options) {
        this.options = options;
    }
    get(did) {
        return __awaiter(this, void 0, void 0, function* () {
            return getIdentityStore(this.options, did);
        });
    }
    getScore(did) {
        return __awaiter(this, void 0, void 0, function* () {
            return getCivicScore(this.options, did);
        });
    }
    search(query, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return searchIdentityStore(this.options, query, type);
        });
    }
}
export default Store;
